export default "__VITE_ASSET__BuFF4g7V__"